// extracted by mini-css-extract-plugin
export default {"transparentAndVerified":"TransparentAndVerified_transparentAndVerified__fRo1k"};